//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ItemList',

    props: ['items', 'title'],

    data(){ return {
        elevation: 1,
    }},

    mounted(){

    }
}
